<div class="flex flex-col gap-6">
  @for (group of groupedClosingFields(); track group.category) {
    <section class="flex flex-col gap-4">
      @if (group.category) {
        <div class="text-(--color-text-primary) font-semibold text-xl">
          {{ group.category }}
        </div>
      }

      <div
        class="grid gap-4 gap-y-6 grid-cols-1"
        [ngClass]="{
          'md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2': colummMax === 2,
          'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3': colummMax === 3,
          'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': colummMax === 4,
        }"
      >
        @for (field of group.fields; track field.Id) {
          @switch (field.ComponentType) {
            @case ('TextArea') {
              @if (field.FormControl) {
                <app-input-general-text
                  [formControlGeneral]="getFieldControl(field)"
                  [label]="field.Description"
                  [placeholder]="field.Description"
                ></app-input-general-text>
              }
            }
            @case ('DropDownList') {
              @if (field.FormControl) {
                <app-input-general-select
                  [formControlGeneral]="getFieldControl(field)"
                  [label]="field.Description"
                  [placeholder]="field.Description"
                  [arrayData]="getSelectOptions(field)"
                ></app-input-general-select>
              }
            }
            @case ('CatalogDropDownList') {
              @if (field.FormControl) {
                <app-input-general-select
                  [formControlGeneral]="getFieldControl(field)"
                  [label]="field.Description"
                  [placeholder]="field.Description"
                  [arrayData]="getCatalogOptions(field)"
                  [inputSelect]="catalogInputSelect"
                ></app-input-general-select>
              }
            }
            @case ('File') {
              @if (field.FormControl) {
                <app-input-file-light
                  class="my-auto"
                  [label]="field.Description"
                  [formControlGeneral]="getFieldControl(field)"
                  [accept]="getFileAccept(field)"
                ></app-input-file-light>
              }
            }
            @default {
              @if (field.FormControl) {
                <app-input-general
                  [formControlGeneral]="getFieldControl(field)"
                  [label]="field.Description"
                  [placeholder]="field.Description"
                  [prefix]="field.Preffix || ''"
                  [suffix]="field.Suffix || ''"
                ></app-input-general>
              }
            }
          }
        }
      </div>
    </section>
  }
</div>
